const CE_ENTRY_TABS = {
  MY_LICENSE: 'myLicense',
  AGENCY_OVERVIEW: 'agencyOverview',
  SKILLS_OVERVIEW: 'skillsOverview',
  ENTRIES: 'entries',
  SETTINGS: 'settings',
};

export default CE_ENTRY_TABS;
